import api from "./api";

const BASE_ENDPOINT = '/carga-horaria';

function getAll() {
    return api.get(`${BASE_ENDPOINT}/list`);
}

function getOneByCod(cod) {
    return api.get(`${BASE_ENDPOINT}/${cod}`);
}

function createNew(form) {
    return api.post(
        `${BASE_ENDPOINT}/create`,
        {...form}
    );
}

function updateOne(cod, form) {
    return api.put(
        `${BASE_ENDPOINT}/update/${cod}`, 
        { ...form }
    );
}

const CargaHorariaApiService = {
    getAll,
    getOneByCod,
    createNew,
    updateOne
}

export default CargaHorariaApiService
